import React, { PureComponent } from 'react';
import { withRouter } from 'common/components/core/router';
import { connect } from 'react-redux';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import compose from 'recompose/compose';
import { translate } from 'react-i18next';

import { selectFactory, SelectTypes } from 'common/components/core/select';
import theme from './ZoneMapUsecaseDropdown.scss';
import { dashboardColors } from 'common/enums/ColorEnum';
import { Checkbox, CheckboxTypes } from 'common/components/core/checkbox';
import { DivWithPopover } from 'common/components/core/wrappers/Div';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';
import ZoneMapSelectors from 'common/redux/selectors/zoneMap';
import ZoneMapUsecaseLabel from 'common/entity/mapMaster/ZoneMapUsecaseLabel';
import Button, { ButtonTypes } from 'common/components/core/button';
import { SizeEnum } from 'common/enums/UIEnums';
import { renderNull } from 'common/utils/ReactUtils';

class ActiveButton extends PureComponent {
    render() {
        const {
            selectProps,
            innerProps,
            innerRef,
            children,
            isDisabled
        } = this.props;
        const {
            popOverContent,
            buttonLabel,
            isMapActive,
            isLoading,
            theme
        } = selectProps;
        return (
            <DivWithPopover
                {...innerProps}
                innerRef={innerRef}
                popOverContent={popOverContent}
                triggerPopoverOn={PopoverTriggerEnum.Hover}
                className={theme.selectControlWrap}
            >
                <Button
                    semibold
                    uppercase
                    theme={theme}
                    disabled={isDisabled}
                    smallLoader
                    enableTooltipOnHover
                    color={
                        isMapActive
                            ? dashboardColors.darkSkyBlue.name
                            : dashboardColors.whiteThree.name
                    }
                    buttonType={ButtonTypes.Solid}
                    label={buttonLabel}
                    className={theme.activeBtn}
                    size={SizeEnum.Small}
                    isLoading={isLoading}
                />
                {children}
            </DivWithPopover>
        );
    }
}

const UseCaseOption = ({
    selectProps: { activeUsecase },
    data,
    innerProps,
    isDisabled,
    isFocused
}) => {
    const { label: optionLabel, value } = data;
    const label = (
        <div className={theme.optionLabelWrap}>
            <div className={theme.optionLabel}>{optionLabel}</div>
            <ZoneMapUsecaseLabel usecase={value} />
        </div>
    );
    const isSelected = activeUsecase === value;
    return (
        <div
            {...innerProps}
            className={classnames(theme.optionContainer, {
                [theme.isFocused]: isFocused,
                [theme.isDisabled]: isDisabled
            })}
        >
            <Checkbox
                theme={theme}
                smallCheckbox
                checked={isSelected}
                checkboxType={CheckboxTypes.Solid}
                checkboxColor={dashboardColors.darkSkyBlue.name}
                label={label}
            />
        </div>
    );
};

const Select = selectFactory({
    Option: UseCaseOption,
    Control: ActiveButton,
    Placeholder: renderNull,
    SingleValue: renderNull,
    IndicatorsContainer: renderNull
});

class ZoneMapUsecaseDropdown extends PureComponent {
    changeActiveUsecases = value => {
        const { activeUsecases, changeActiveUsecases, mapId } = this.props;
        if (value) {
            const selectedUsecase = value.value;
            const updatedUsecases =
                selectedUsecase !== activeUsecases[0] ? [selectedUsecase] : [];
            changeActiveUsecases({ mapId }, updatedUsecases);
        }
    };

    render() {
        const {
            usecases,
            activeUsecases,
            activeVersion,
            isSettingUsecase,
            theme,
            t
        } = this.props;
        const [activeUsecase] = activeUsecases || [];
        const disabled = !activeVersion && activeVersion !== 0;
        const isMapActive =
            !disabled && activeUsecases && !!activeUsecases.length;
        const buttonLabel = t(
            isMapActive ? 'zoneMap.active' : 'zoneMap.inactive'
        );
        const popOverContent = disabled ? t('zoneMap.freezeToSetActive') : '';
        return (
            <Select
                menuAutoWidth
                isLoading={isSettingUsecase}
                triggerPopoverOn={PopoverTriggerEnum.Hover}
                disabled={disabled}
                popOverContent={popOverContent}
                activeUsecase={activeUsecase}
                isMapActive={isMapActive}
                buttonLabel={buttonLabel}
                theme={theme}
                hideSelectedOptions={false}
                selectType={SelectTypes.Outline}
                options={usecases}
                className={classnames(theme.usecasesDropdown)}
                isClearable={false}
                isSearchable={false}
                onChange={this.changeActiveUsecases}
            />
        );
    }
}

const mapStateToProps = (state, props) => {
    const isSettingUsecase = ZoneMapSelectors.isSettingMapUsecases(
        state,
        props
    );
    return {
        isSettingUsecase
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps),
    themr('ZoneMapUsecaseDropdown', theme),
    translate('entityManagement')
)(ZoneMapUsecaseDropdown);
